import styled from "styled-components";

export const Wrapper = styled.div`
  .action {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .accept {
    color: #5d78ff;
    border: 1px solid #5d78ff;
    font-weight: 700;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    padding: 4px 22px;
    border-radius: 3px;
    word-break: normal;
  }

  .reject {
    padding: 4px 22px;
    color: #ff2828;
    font-weight: 700;
    border: 1px solid #ff2828 !important;
    font-size: 14px;
    background: white;
    letter-spacing: 1px;
    border-radius: 3px;
    word-break: normal;
  }
  .userName {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .profileIcon {
    width: 16px;
    height: 16px;
    stroke: blue;
    fill: blue;
    margin-left: 5px;
  }
  .viewHistory {
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    height: 30px;
    outline: none;
    padding: 0 10px;
    font-weight: 600;
    text-decoration: none;
    line-height: 25px;
    color: #000;
  }
`;

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  max-width: 80%;
  min-width: 50%;
  background-color: white;
  padding: 16px;
  h3 {
    margin-top: 10px;
    text-align: center;
  }
  .closeButton{
    position: absolute;
    right: 20px;
    top: 20px;
    background-color: #ffd3d3;
    padding: 7px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  .three-dot {
    width: 100%;
    position: static;
    height: 300px;
  }
  .tableContainer {
    width: 100%;
  }
  .modalTable {
    width: 100%;
    height: auto;
    overflow: auto;
    min-width: 800px;
    margin-top: 10px;
  }
  .auctionTable {
    width: 100%;
  }
  tbody {
    display: block;
    max-height: 50vh;
    overflow-y: auto;
    margin-top: 20px;
  }
  .tableHead {
    display: flex;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.6);
    border-radius: 10px;
  }
  .table-row {
    display: flex;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 0;
    border-radius: 10px;
    border-radius: 0;
  }
  .table-row:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .table-row:first-child {
    margin-top: 0px;
  }
  .table-row th,
  .table-row td {
    min-width: 10%;
    width: 15%;
    padding: 15px 5px;
    display: block;
    justify-content: center;
    align-self: center;
    text-align: center;
    word-break: break-word;
  }
  .Pending {
    color: #ffb700;
  }
  .Accepted {
    color: #5d78ff;
  }
  .Rejected {
    color: #ff2828;
  }
  @media (max-width: 768px) {
    tbody {
      max-height: 40vh;
    }
  }
`;
